module.exports = __webpack_public_path__ + "static/UnclickMedicalExpenses-cf31e3e11459f45afa00d36a30e4c110.png";